import Block from "../Block";
import "./BlockJump.css";
import Menu from "../Menu/Menu";
import useBlockCamera from "/src/features/editor/hook/block/useBlockCamera";
import imageJumpPreview from "/src/features/editor/image/jump_preview.png";
import BlockLinkEnd from "../BlockLinkEnd/BlockLinkEnd";

// Component for create the block jump
function BlockJump({name, x, y, object_id, data, lowVersion, type}) {

    const { followBlock } = useBlockCamera();

    const block = {
        name, x, y, id : object_id, imageLow : imageJumpPreview, lowVersion, type, data, className : "magic"
    }

    const className = data.jump_id ? "block_magic_jump_btn" : "block_magic_jump_btn disabled"
    return (
        <Block {...block}>
            {!lowVersion && 
                <>
                    <BlockLinkEnd parent_block_id={object_id} className="magic" style={{left: "-15px", top: "42px", transform: "rotate(270deg)"}}/>
                    <Menu className="magic" id={object_id}/>
                    <div className="block_magic_icon"></div>
                    <div className={className} onClick={() => data.jump_id && followBlock(data.jump_id.object_id)}><div>{name}</div></div>
                </>
            }
            
        </Block>
    )
}

export default BlockJump;
